import * as React from "react"

function Location(props) {
  return (
    <svg
      viewBox="0 0 26 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#prefix__clip0_15_91)">
        <path
          d="M13 0C5.82 0 0 6.21 0 13.87c0 5.32 6.28 13.09 10.11 18.62 1.39 2.01 4.38 2.01 5.78 0C19.72 26.96 26 19.19 26 13.87 26 6.21 20.18 0 13 0zm0 17.16c-2.21 0-4-1.81-4-4.04s1.79-4.04 4-4.04 4 1.81 4 4.04-1.79 4.04-4 4.04z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="prefix__clip0_15_91">
          <path fill="none" d="M0 0h26v34H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default Location
